import { render, staticRenderFns } from "./dashHome.vue?vue&type=template&id=e04ca09c&scoped=true&"
import script from "./dashHome.vue?vue&type=script&lang=js&"
export * from "./dashHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04ca09c",
  null
  
)

export default component.exports